<template>
    <div>
  
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class='flex'>
          <el-input
            v-model="getSysToneList_data.stName"
            placeholder="请输入语气词名"
            clearable
            size='small'
            style="max-width:380px;"/>
          <el-button
            v-click.getSysToneList
            type="primary"
            icon='el-icon-search'
            size='small'
            style='margin-left:10px;'
          >搜索
          </el-button>
        </el-col>
        <el-col :span="6" >
          <el-button
            v-if='addSysTone'
            @click=" $form('addSysTone') "
            size='small'
            type="primary"
            style="float:right"
            icon='el-icon-circle-plus'
          >添加语气词
          </el-button>
        </el-col>
      </el-row>
  
      <mytable
        :tableColums='tableColums_getSysToneList'
        api='getSysToneList'
        updateapi='updateSysTone'
        :height="H-165" >
      </mytable> 
  
      <myform
        :viewobj='{
          addSysTone:    [ "新增语气词信息", "el-icon-circle-plus" ],
          updateSysTone: [ "修改语气词信息", "el-icon-edit-outline"],
          $succeed$: getSysToneList
        }'
        @close='$form("addSysTone","reset")' >
        <hide slot='stId' />
      </myform>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        vtId: null,
  
        tableColums_getSysToneList: {
          $selection: false,
  
          stName: '语气词',
  
  
  
          // ycDelete: ['状态',,'@v-if: 1:正常 🔍#(--Themecolor),  3:弃用 🖊#warn, 2:已删除 ❌#danger+'],
  
          $operation: [
            '操作', 200,
            this.updateSysTone && `@text: 编辑#success
             @click: $form("updateSysTone",$row)
            `,
            this.deleteSysTone && `@text: 删除#danger
             @click: _confirm('确定要删除该语气词吗?')
                     .trigger('deleteSysTone',{stIds:$row.stId})
                     .trigger('getSysToneList')
            `,
          ],
  
        },
  
      };
    },
  
    watch: {
      
    },
  
    methods: {},
  
    created() {
      this.getSysToneList();
    }
  };
  </script>
  
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/rule/toneType.vue